import { Link as RouterLink } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";

export function NotFoundPage() {
  return (
    <Box textAlign="center" mt={10}>
      <Typography variant="h2" fontWeight={700}>
        404
      </Typography>
      <Typography variant="h6" color="text.secondary" mb={3}>
        The page you're looking for doesn't exist.
      </Typography>
      <Button component={RouterLink} to="/dashboard" variant="contained">
        Go to Dashboard
      </Button>
    </Box>
  );
}

export default NotFoundPage;
